/* La bulle « ajouté au panier ».
   Dawn en fait une boîte de dialogue : piège de focus, fermeture au clic
   n'importe où, et elle reste ouverte tant qu'on ne la ferme pas. Ici c'est
   une notification : elle s'affiche, on peut cliquer « Voir mon panier », et
   elle s'efface d'elle-même après quelques secondes (le survol la retient).
   Le compteur de l'icône du panier reçoit au passage une pulsation. */
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.duree = 5000;
    this.minuteur = null;

    /* Sur téléphone, un panneau qui monte du bas et reste ouvert ; sur
       ordinateur, une bulle qui s'efface seule. */
    this.mobile = window.matchMedia('(max-width: 749px)');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('[data-fermer]').forEach((bouton) => bouton.addEventListener('click', () => this.close()));
    this.notification.addEventListener('mouseenter', () => this.arreter());
    this.notification.addEventListener('mouseleave', () => this.armer());
    this.notification.addEventListener('focusin', () => this.arreter());
    this.notification.addEventListener('focusout', () => this.armer());
    /* L'en-tête collant glisse au défilement : la bulle le suit. */
    window.addEventListener(
      'scroll',
      () => {
        if (!this.notification.classList.contains('active')) return;
        requestAnimationFrame(() => this.placer());
        /* L'en-tête finit de glisser après le défilement : on remesure. */
        clearTimeout(this.suiviMinuteur);
        this.suiviMinuteur = setTimeout(() => this.placer(), 350);
      },
      { passive: true }
    );
    const section = document.querySelector('.section-header');
    if (section) section.addEventListener('transitionend', () => this.placer());
  }

  open() {
    this.placer();
    setTimeout(() => this.placer(), 400);
    this.classList.add('is-open');
    this.notification.classList.add('animate', 'active');
    this.armer();
    this.dispatchCartViewEvent();
  }

  /* Sous le bord bas de l'en-tête, alignée à droite sur l'icône du panier. */
  placer() {
    const entete = document.querySelector('.header-wrapper');
    const icone = document.getElementById('cart-icon-bubble');
    /* Position réelle de l'en-tête (masqué au défilement : bord à 0). open()
       remesure après sa réapparition, et le défilement remesure aussi. */
    const bas = entete ? entete.getBoundingClientRect().bottom : 0;
    this.notification.style.setProperty('--bulle-top', `${Math.max(bas, 0) + 10}px`);
    if (icone) {
      const droite = window.innerWidth - icone.getBoundingClientRect().right;
      this.notification.style.setProperty('--bulle-right', `${Math.max(droite, 15)}px`);
    }
  }

  armer() {
    this.arreter();
    /* Le panneau de téléphone attend qu'on le ferme. */
    if (this.mobile.matches) return;
    this.minuteur = setTimeout(() => this.close(), this.duree);
  }

  arreter() {
    if (this.minuteur) clearTimeout(this.minuteur);
    this.minuteur = null;
  }

  // The notification's outer element is server-rendered once at page load, so
  // its `cart` Liquid object reflects the pre-add state. We keep an explicit
  // /cart.json fetch on open for the event payload.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    this.arreter();
    this.classList.remove('is-open');
    this.notification.classList.remove('active');
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const cible = document.getElementById(section.id);
      if (!cible) return;
      cible.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.pulser();
    if (this.header) this.header.reveal();
    this.open();
  }

  pulser() {
    const bulle = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bulle) return;
    bulle.classList.remove('is-pulse');
    void bulle.offsetWidth;
    bulle.classList.add('is-pulse');
    bulle.addEventListener('animationend', () => bulle.classList.remove('is-pulse'), { once: true });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
